const keyCodes = {
  ENTER: 13
}

export { keyCodes }